import styled from "styled-components";

import type { BadgeType } from "./Badge";
import { Badge } from "./Badge";

interface Props {
  badges: BadgeType[];
}

export const BadgeList: React.VFC<Props> = ({ badges = [] }) => {
  return (
    <Container>
      {badges.map(badge => (
        <Badge key={badge} type={badge} />
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 4px;
  overflow: hidden;
`;
